module.exports = __webpack_public_path__ + "files/924039125b7c0e233cf3710fd7fc887b.png";